import { render } from "./gradesheetsd.vue?vue&type=template&id=99d91fe8&scoped=true"
import script from "./gradesheetsd.vue?vue&type=script&lang=js"
export * from "./gradesheetsd.vue?vue&type=script&lang=js"

import "./gradesheetsd.vue?vue&type=style&index=0&id=99d91fe8&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99d91fe8"]])

export default __exports__